import { Button } from '@/components/ui/button'

import homeIcon from '@/assets/svg/home.svg'
import businessIcon from '@/assets/svg/business.svg'
import useSetupStore from '@/store/useSetupStore'
import { TEAM_TYPES } from '@/data/constants/constants'

export default function TeamType() {
  const setTeamType = useSetupStore((state) => state.setTeamType)
  const teamType = useSetupStore((state) => state.teamType)

  return (
    <div>
      <h3 className="font-bold text-txt-secondary">Choose Account Type</h3>

      <div className="mt-5 grid grid-cols-2 gap-3 tablet:mt-8 tablet:gap-5">
        <Button
          type="button"
          variant="secondary"
          className={`h-[160px] border-accent bg-gray-low font-raleway text-xl text-txt-primary data-[account='business']:border data-[account='business']:bg-accent-tr-24 data-[account='business']:text-txt-accent tablet:h-[328px]`}
          data-account={teamType?.toLowerCase()}
          onClick={() => setTeamType(TEAM_TYPES.BUSINESS)}
        >
          <div className="flex flex-col items-center justify-center gap-1">
            <img src={businessIcon} alt="business" />
            <h4> For business</h4>
          </div>
        </Button>
        <Button
          type="button"
          className={`h-full border-accent bg-gray-low font-raleway text-xl text-txt-primary data-[account='personal']:border data-[account='personal']:bg-accent-tr-24 data-[account='personal']:text-txt-accent`}
          variant="secondary"
          data-account={teamType?.toLowerCase()}
          onClick={() => setTeamType(TEAM_TYPES.PERSONAL)}
        >
          <div className="flex flex-col items-center justify-center gap-1">
            <img src={homeIcon} alt="home" className="size-8" />

            <h4> Person profile</h4>
          </div>
        </Button>
      </div>
    </div>
  )
}
